import { Injectable }    from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';
import { AuthService } from '../login/auth.service';

@Injectable()
export class ContactService {

  private headers: Headers;
  private url = environment.apiUrl;

  constructor(private http: Http, private authService: AuthService) {
    this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
  }

  public send(data: ContactData): Promise<any> {
    return this.http
      .post(this.url+'/contact', data, {headers: this.headers})
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}

export class ContactData {
    public firstName: string = "";
    public lastName: string = "";
    public email: string = "";
    public message: string = "";
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/contact/contact.service.ts